export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिन्दी" },
  { code: "ar", label: "العربية" },
  { code: "es", label: "Español" },
  { code: "lb", label: "Lëtzebuergesch" },
  { code: "de", label: "Deutsch" },
  { code: "fr", label: "Français" },
  { code: "pt", label: "Português" },
  { code: "it", label: "Italiano" },
  { code: "ja", label: "日本語" },
];

export const translations = {
  en: {
    nav: { founders: "Founders", services: "Services", work: "Work", cta: "Start a project" },
    hero: {
      eyebrow: "Web Builders — Web Design Studio",
      l1: "WE BUILD",
      l2: "THE WEB.",
      l3: "BRILLIANTLY.",
      sub: "Two 12-year-old twins from India designing and coding striking, fast websites — no templates, no bloat, no middlemen.",
      cta: "Start your project",
      scroll: "Scroll",
    },
    marquee: ["Run by two prodigies", "Custom web builds", "Premium design", "Fast shipping", "Zero templates", "Web Builders"],
    founders: {
      overline: "The founders",
      h2a: "Twin prodigies.",
      h2b: "One studio.",
      p1: "Web Builders is run by Vikraanth and Vaibhhav — 12-year-old twins from India who fell in love with the web and got frighteningly good at building it. Design, code, copy and launch: the two of them do it all themselves.",
      p2: "Every pixel passes through their four hands, and every client gets founders who actually answer.",
      role: "Co-founder, Web Builders",
      twins: "Twins · Age 12 · India",
      mentor: {
        label: "Our mentor",
        body: "A software professional based in Luxembourg, she has worked with global product and software firms like BMC Software, Kodiak Networks and Emphasis.",
        extra: "She brings about 20 years of technology, design, architecture and implementation experience.",
        tags: ["Luxembourg", "20 Years' Experience"],
      },
      daisy: {
        label: "Honourable mention",
        body: "She is the kids' motivation and support, always there for them. She is one of the cutest sisters ever.",
      },
      points: [
        { t: "Design + code, same hands", b: "No handoffs, no telephone game. The kid who designs your site is the kid who ships it." },
        { t: "Direct line to the builders", b: "You talk to the two people actually building your website. Nothing gets lost in translation." },
        { t: "Young eyes, old craft", b: "We grew up inside the internet, so we build it the way it should feel — fast, sharp, alive." },
      ],
    },
    services: {
      overline: "What we build",
      h2: "Pick your build.",
      side: "Every project is designed and coded from scratch around your idea — never squeezed into a template.",
      items: [
        { t: "Landing Pages", b: "One page, one job: make visitors act. Sharp copy, bold design, load times that don't blink." },
        { t: "Business Websites", b: "Multi-page sites that make small businesses look established from day one." },
        { t: "Online Stores", b: "Storefronts built to sell — clean catalogs, smooth checkout, zero friction." },
        { t: "Portfolios & Resumes", b: "Personal sites that get you remembered — and hired." },
        { t: "Web Apps & Dashboards", b: "Custom tools, booking systems and dashboards wired to real data." },
      ],
      customT: "Something else entirely?",
      customB: "Tell us the idea — we'll shape it into pages and a plan with you.",
    },
    work: {
      overline: "The work",
      h2a: "Fresh builds,",
      h2b: "zero templates.",
      side: "Concepts we craft and the kind of sites we ship. Yours goes right here.",
      cards: [
        { tag: "E-commerce concept", title: "Dark-mode storefront" },
        { tag: "App concept", title: "Mobile experience" },
      ],
      ctaT: "Your project goes here",
      ctaB: "Claim the spot — start your project",
    },
    contact: {
      overline: "Get in touch",
      h2a: "Interested?",
      h2b: "Good. Tell us.",
      body: "Tell us how many pages you want and what they should do. If we reply, we'll send our WhatsApp number and a custom price — straight to your inbox.",
      name: "Your name *",
      namePh: "Your full name",
      email: "Email *",
      emailPh: "you@company.com",
      business: "Business / project name (optional)",
      businessPh: "Your company",
      pages: "How many pages do you want? *",
      pagesHint: "Not sure? Pick any number — we'll figure it out together.",
      features: "What do you want in it?",
      message: "Tell us more (optional)",
      messagePh: "What's the idea? Who's it for? Any sites you like?",
      submit: "Send my idea",
      sending: "Sending...",
      hint: "We reply personally — expect our WhatsApp number and a custom price in your inbox.",
      successT: "Idea received.",
      successBody: "Thanks, {name}! We'll reply to {email} with our WhatsApp number and a custom price for your build.",
      sendAnother: "Send another idea",
      errName: "Please tell us your name.",
      errEmail: "Please enter a valid email so we can reply.",
      toastSuccess: "Idea sent! Watch your inbox for our reply.",
    },
    features: ["Landing page", "Business website", "Online store", "Portfolio", "Blog", "Booking system", "Dashboard / web app", "Something else"],
    footer: {
      overline: "Interested? Reach out.",
      body: "Email us anytime — we reply personally with our WhatsApp number and a custom price for your build.",
      tagline: "Run by two prodigies",
      copyright: "© {year} Web Builders",
    },
  },
  hi: {
    nav: { founders: "संस्थापक", services: "सेवाएँ", work: "काम", cta: "प्रोजेक्ट शुरू करें" },
    hero: {
      eyebrow: "वेब बिल्डर्स — वेब डिज़ाइन स्टूडियो",
      l1: "हम बनाते हैं",
      l2: "वेब।",
      l3: "शानदार ढंग से।",
      sub: "भारत के 12 साल के जुड़वा बच्चों द्वारा डिज़ाइन और कोड की गई शानदार, तेज़ वेबसाइटें — न टेम्पलेट, न बीच के लोग।",
      cta: "अपना प्रोजेक्ट शुरू करें",
      scroll: "स्क्रॉल",
    },
    marquee: ["दो प्रतिभाशाली बच्चों द्वारा संचालित", "कस्टम वेब बिल्ड", "प्रीमियम डिज़ाइन", "तेज़ डिलीवरी", "कोई टेम्पलेट नहीं", "वेब बिल्डर्स"],
    founders: {
      overline: "संस्थापक",
      h2a: "जुड़वा प्रतिभाशाली।",
      h2b: "एक स्टूडियो।",
      p1: "वेब बिल्डर्स चलाते हैं विक्रांत और वैभव — भारत के 12 साल के जुड़वा बच्चे, जिन्हें वेब से प्यार हो गया और वे इसे बनाने में कमाल के हो गए। डिज़ाइन, कोड, कॉपी और लॉन्च — सब कुछ दोनों खुद करते हैं।",
      p2: "हर पिक्सल उनके चार हाथों से गुजरता है, और हर ग्राहक को वे संस्थापक मिलते हैं जो सच में जवाब देते हैं।",
      role: "सह-संस्थापक, वेब बिल्डर्स",
      twins: "जुड़वा · उम्र 12 · भारत",
      mentor: {
        label: "हमारी मेंटर",
        body: "लक्ज़मबर्ग में स्थित सॉफ़्टवेयर प्रोफ़ेशनल, उन्होंने BMC Software, Kodiak Networks और Emphasis जैसी वैश्विक प्रोडक्ट और सॉफ़्टवेयर कंपनियों में काम किया है।",
        extra: "वे तकनीक, डिज़ाइन, आर्किटेक्चर और इम्प्लीमेंटेशन का लगभग 20 साल का अनुभव लाती हैं।",
        tags: ["लक्ज़मबर्ग", "20 साल का अनुभव"],
      },
      daisy: {
        label: "सम्मानित उल्लेख",
        body: "वह बच्चों की प्रेरणा और सहारा है, हमेशा उनके साथ। वह अब तक की सबसे प्यारी बहनों में से एक है।",
      },
      points: [
        { t: "डिज़ाइन + कोड, वही हाथ", b: "कोई हैंडऑफ़ नहीं, कोई टेलीफ़ोन गेम नहीं। जो बच्चा आपकी साइट डिज़ाइन करता है, वही उसे लॉन्च भी करता है।" },
        { t: "बिल्डर्स से सीधी बात", b: "आप उन्हीं दो लोगों से बात करते हैं जो असल में आपकी वेबसाइट बना रहे हैं। कुछ भी बीच में नहीं खोता।" },
        { t: "युवा नज़र, पुरानी कला", b: "हम इंटरनेट के अंदर बड़े हुए, इसलिए हम इसे वैसा बनाते हैं जैसा इसे महसूस होना चाहिए — तेज़, सटीक, जीवंत।" },
      ],
    },
    services: {
      overline: "हम क्या बनाते हैं",
      h2: "अपनी पसंद चुनें।",
      side: "हर प्रोजेक्ट आपके आइडिया के हिसाब से शुरू से डिज़ाइन और कोड किया जाता है — कभी टेम्पलेट में नहीं ठूँसा जाता।",
      items: [
        { t: "लैंडिंग पेज", b: "एक पेज, एक काम: विज़िटर को कार्रवाई करवाना। सटीक कॉपी, बोल्ड डिज़ाइन, बिजली जैसी स्पीड।" },
        { t: "बिज़नेस वेबसाइट", b: "कई पेजों वाली साइटें जो छोटे बिज़नेस को पहले दिन से स्थापित दिखाती हैं।" },
        { t: "ऑनलाइन स्टोर", b: "बेचने के लिए बने स्टोरफ्रंट — साफ़ कैटलॉग, आसान चेकआउट, कोई झंझट नहीं।" },
        { t: "पोर्टफोलियो और रिज़्यूमे", b: "निजी साइटें जो आपको यादगार — और नियुक्त — बनाती हैं।" },
        { t: "वेब ऐप्स और डैशबोर्ड", b: "कस्टम टूल, बुकिंग सिस्टम और डैशबोर्ड, असली डेटा से जुड़े हुए।" },
      ],
      customT: "कुछ बिल्कुल अलग?",
      customB: "हमें आइडिया बताएं — हम उसे पेजों और योजना में ढाल देंगे।",
    },
    work: {
      overline: "हमारा काम",
      h2a: "ताज़ा बिल्ड,",
      h2b: "शून्य टेम्पलेट।",
      side: "हम जो कॉन्सेप्ट बनाते हैं और जैसी साइटें शिप करते हैं। आपकी साइट ठीक यहाँ आएगी।",
      cards: [
        { tag: "ई-कॉमर्स कॉन्सेप्ट", title: "डार्क-मोड स्टोरफ्रंट" },
        { tag: "ऐप कॉन्सेप्ट", title: "मोबाइल अनुभव" },
      ],
      ctaT: "आपका प्रोजेक्ट यहाँ आएगा",
      ctaB: "जगह बुक करें — प्रोजेक्ट शुरू करें",
    },
    contact: {
      overline: "संपर्क करें",
      h2a: "दिलचस्पी है?",
      h2b: "बढ़िया। बताइए।",
      body: "बताइए कि आपको कितने पेज चाहिए और उन्हें क्या करना है। अगर हम जवाब देते हैं, तो हम अपना WhatsApp नंबर और कस्टम कीमत — सीधे आपके इनबॉक्स में भेजेंगे।",
      name: "आपका नाम *",
      namePh: "आपका पूरा नाम",
      email: "ईमेल *",
      emailPh: "you@company.com",
      business: "बिज़नेस / प्रोजेक्ट का नाम (वैकल्पिक)",
      businessPh: "अपनी कंपनी का नाम",
      pages: "आपको कितने पेज चाहिए? *",
      pagesHint: "पक्का नहीं? कोई भी नंबर चुनें — हम मिलकर तय कर लेंगे।",
      features: "इसमें क्या-क्या चाहिए?",
      message: "और बताइए (वैकल्पिक)",
      messagePh: "आइडिया क्या है? किसके लिए है? कोई पसंदीदा साइट?",
      submit: "मेरा आइडिया भेजें",
      sending: "भेजा जा रहा है...",
      hint: "हम खुद जवाब देते हैं — आपके इनबॉक्स में हमारा WhatsApp नंबर और कस्टम कीमत मिलेगी।",
      successT: "आइडिया मिल गया।",
      successBody: "धन्यवाद, {name}! हम {email} पर अपना WhatsApp नंबर और आपके बिल्ड की कस्टम कीमत भेजेंगे।",
      sendAnother: "एक और आइडिया भेजें",
      errName: "कृपया अपना नाम बताएं।",
      errEmail: "कृपया सही ईमेल डालें ताकि हम जवाब दे सकें।",
      toastSuccess: "आइडिया भेज दिया! अपना इनबॉक्स देखते रहें।",
    },
    features: ["लैंडिंग पेज", "बिज़नेस वेबसाइट", "ऑनलाइन स्टोर", "पोर्टफोलियो", "ब्लॉग", "बुकिंग सिस्टम", "डैशबोर्ड / वेब ऐप", "कुछ और"],
    footer: {
      overline: "दिलचस्पी है? संपर्क करें।",
      body: "कभी भी ईमेल करें — हम खुद जवाब देते हैं, अपने WhatsApp नंबर और आपके बिल्ड की कस्टम कीमत के साथ।",
      tagline: "दो प्रतिभाशाली बच्चों द्वारा संचालित",
      copyright: "© {year} वेब बिल्डर्स",
    },
  },
  ar: {
    nav: { founders: "المؤسسان", services: "الخدمات", work: "أعمالنا", cta: "ابدأ مشروعك" },
    hero: {
      eyebrow: "ويب بيلدرز — استوديو تصميم الويب",
      l1: "نحن نبني",
      l2: "الويب.",
      l3: "ببراعة.",
      sub: "توأمان من الهند في الثانية عشرة يصمّمان ويبرمجان مواقع ويب سريعة ولافتة — بلا قوالب وبلا وسطاء.",
      cta: "ابدأ مشروعك",
      scroll: "مرّر",
    },
    marquee: ["يديرها عبقريان صغيران", "مواقع مخصصة", "تصميم فاخر", "تسليم سريع", "بلا قوالب", "ويب بيلدرز"],
    founders: {
      overline: "المؤسسان",
      h2a: "عبقريان توأمان.",
      h2b: "استوديو واحد.",
      p1: "يدير ويب بيلدرز فيكرانت وفايبهاف — توأمان من الهند في الثانية عشرة، عشقا الويب حتى أتقنا بناءه. التصميم والبرمجة والنصوص والإطلاق: يفعلان كل شيء بأنفسهما.",
      p2: "كل بكسل يمر عبر أيديهما الأربع، وكل عميل يحصل على مؤسسَين يردّان فعلاً.",
      role: "مؤسس مشارك، ويب بيلدرز",
      twins: "توأمان · 12 سنة · الهند",
      mentor: {
        label: "مرشدتنا",
        body: "محترفة برمجيات ومقيمة في لوكسمبورغ، عملت مع شركات منتجات وبرمجيات عالمية مثل BMC Software وKodiak Networks وEmphasis.",
        extra: "تجلب نحو 20 عاماً من الخبرة في التقنية والتصميم والهندسة المعمارية والتنفيذ.",
        tags: ["لوكسمبورغ", "20 عاماً من الخبرة"],
      },
      daisy: {
        label: "ذكر مشرّف",
        body: "إنها مصدر تحفيز الطفلين ودعمهما، وهي دائماً إلى جانبهما. إنها من ألطف الأخوات على الإطلاق.",
      },
      points: [
        { t: "التصميم والبرمجة بأيدٍ واحدة", b: "لا تسليمات ولا لعبة هاتف. من يصمم موقعك هو من يطلقه." },
        { t: "تواصل مباشر مع البنّائين", b: "تتحدث مع الشخصين اللذين يبنيان موقعك فعلاً. لا شيء يضيع في الطريق." },
        { t: "عيون شابة وحرفة عريقة", b: "نشأنا داخل الإنترنت، فنبنيه كما يجب أن يكون — سريعاً وحاداً وحياً." },
      ],
    },
    services: {
      overline: "ماذا نبني",
      h2: "اختر ما تريد.",
      side: "كل مشروع يُصمم ويُبرمج من الصفر حول فكرتك — لا يُحشر أبداً في قالب جاهز.",
      items: [
        { t: "صفحات هبوط", b: "صفحة واحدة ومهمة واحدة: دفع الزائر للفعل. نص حاد، تصميم جريء، سرعة البرق." },
        { t: "مواقع الأعمال", b: "مواقع متعددة الصفحات تجعل الشركات الصغيرة تبدو راسخة منذ اليوم الأول." },
        { t: "متاجر إلكترونية", b: "واجهات متاجر مبنية للبيع — كتالوجات نظيفة ودفع سلس بلا عوائق." },
        { t: "معارض أعمال وسير ذاتية", b: "مواقع شخصية تجعلك محفوظاً في الأذهان — ومُوظَّفاً." },
        { t: "تطبيقات ويب ولوحات تحكم", b: "أدوات مخصصة وأنظمة حجز ولوحات تحكم مربوطة ببيانات حقيقية." },
      ],
      customT: "شيء مختلف تماماً؟",
      customB: "أخبرنا بالفكرة — سنحوّلها معك إلى صفحات وخطة.",
    },
    work: {
      overline: "أعمالنا",
      h2a: "بناء جديد،",
      h2b: "بلا قوالب.",
      side: "نماذج نصنعها ونوع المواقع التي نسلّمها. موقعك سيكون هنا.",
      cards: [
        { tag: "نموذج تجارة إلكترونية", title: "واجهة متجر بالوضع الداكن" },
        { tag: "نموذج تطبيق", title: "تجربة جوال" },
      ],
      ctaT: "مشروعك يحتل هذه المساحة",
      ctaB: "احجز مكانك — ابدأ مشروعك",
    },
    contact: {
      overline: "تواصل معنا",
      h2a: "مهتم؟",
      h2b: "رائع. أخبرنا.",
      body: "أخبرنا كم صفحة تريد وما الذي يجب أن تفعله. إن رددنا، سنرسل رقم واتساب وسعراً مخصصاً — مباشرة إلى بريدك.",
      name: "اسمك *",
      namePh: "اسمك الكامل",
      email: "البريد الإلكتروني *",
      emailPh: "you@company.com",
      business: "اسم المشروع / الشركة (اختياري)",
      businessPh: "اسم شركتك",
      pages: "كم عدد الصفحات التي تريدها؟ *",
      pagesHint: "غير متأكد؟ اختر أي رقم — سنكتشف ذلك معاً.",
      features: "ماذا تريد فيها؟",
      message: "أخبرنا المزيد (اختياري)",
      messagePh: "ما الفكرة؟ لمن الموقع؟ هل تعجبك مواقع معينة؟",
      submit: "أرسل فكرتي",
      sending: "جارٍ الإرسال...",
      hint: "نرد شخصياً — توقّع رقم واتساب وسعراً مخصصاً في بريدك.",
      successT: "وصلتنا فكرتك.",
      successBody: "شكراً {name}! سنرد على {email} برقم واتساب وسعر مخصص لمشروعك.",
      sendAnother: "أرسل فكرة أخرى",
      errName: "من فضلك أخبرنا باسمك.",
      errEmail: "أدخل بريداً إلكترونياً صحيحاً لنتمكن من الرد.",
      toastSuccess: "تم إرسال الفكرة! راقب بريدك.",
    },
    features: ["صفحة هبوط", "موقع أعمال", "متجر إلكتروني", "معرض أعمال", "مدونة", "نظام حجز", "لوحة تحكم / تطبيق ويب", "شيء آخر"],
    footer: {
      overline: "مهتم؟ تواصل معنا.",
      body: "راسلنا في أي وقت — نرد شخصياً برقم واتساب وسعر مخصص لمشروعك.",
      tagline: "يديرها عبقريان صغيران",
      copyright: "© {year} ويب بيلدرز",
    },
  },
  es: {
    nav: { founders: "Fundadores", services: "Servicios", work: "Trabajos", cta: "Empezar proyecto" },
    hero: {
      eyebrow: "Web Builders — Estudio de diseño web",
      l1: "CONSTRUIMOS",
      l2: "LA WEB.",
      l3: "BRILLANTEMENTE.",
      sub: "Dos gemelos de 12 años de la India que diseñan y programan webs rápidas y sorprendentes — sin plantillas ni intermediarios.",
      cta: "Empieza tu proyecto",
      scroll: "Desliza",
    },
    marquee: ["Dirigido por dos prodigios", "Webs a medida", "Diseño premium", "Entrega rápida", "Cero plantillas", "Web Builders"],
    founders: {
      overline: "Los fundadores",
      h2a: "Gemelos prodigio.",
      h2b: "Un solo estudio.",
      p1: "Web Builders está dirigido por Vikraanth y Vaibhhav, gemelos de 12 años de la India que se enamoraron de la web y se volvieron asombrosamente buenos construyéndola. Diseño, código, textos y lanzamiento: lo hacen todo ellos mismos.",
      p2: "Cada píxel pasa por sus cuatro manos, y cada cliente habla con fundadores que realmente responden.",
      role: "Cofundador, Web Builders",
      twins: "Gemelos · 12 años · India",
      mentor: {
        label: "Nuestra mentora",
        body: "Profesional del software, con sede en Luxemburgo, ha trabajado con firmas globales de productos y software como BMC Software, Kodiak Networks y Emphasis.",
        extra: "Aporta unos 20 años de experiencia en tecnología, diseño, arquitectura e implementación.",
        tags: ["Luxemburgo", "20 años de experiencia"],
      },
      daisy: {
        label: "Mención de honor",
        body: "Es la motivación y el apoyo de los chicos, siempre ahí para ellos. Es una de las hermanas más adorables que existen.",
      },
      points: [
        { t: "Diseño + código, las mismas manos", b: "Sin entregas ni teléfono roto. Quien diseña tu web es quien la lanza." },
        { t: "Línea directa con los creadores", b: "Hablas con las dos personas que realmente construyen tu web. Nada se pierde por el camino." },
        { t: "Ojos jóvenes, oficio clásico", b: "Crecimos dentro de internet, así que lo construimos como debe sentirse: rápido, nítido, vivo." },
      ],
    },
    services: {
      overline: "Lo que construimos",
      h2: "Elige tu proyecto.",
      side: "Cada proyecto se diseña y programa desde cero alrededor de tu idea — nunca se mete en una plantilla.",
      items: [
        { t: "Páginas de aterrizaje", b: "Una página, un objetivo: que el visitante actúe. Texto afilado, diseño audaz, velocidad extrema." },
        { t: "Webs de empresa", b: "Sitios de varias páginas que hacen que un pequeño negocio parezca consolidado desde el primer día." },
        { t: "Tiendas online", b: "Escaparates hechos para vender: catálogos limpios, pago fluido, cero fricción." },
        { t: "Portafolios y currículums", b: "Webs personales que te hacen memorable — y contratable." },
        { t: "Apps web y paneles", b: "Herramientas a medida, sistemas de reserva y paneles conectados a datos reales." },
      ],
      customT: "¿Algo totalmente distinto?",
      customB: "Cuéntanos la idea — la convertiremos juntos en páginas y en un plan.",
    },
    work: {
      overline: "El trabajo",
      h2a: "Creaciones nuevas,",
      h2b: "cero plantillas.",
      side: "Conceptos que creamos y el tipo de webs que entregamos. La tuya va justo aquí.",
      cards: [
        { tag: "Concepto de e-commerce", title: "Escaparate en modo oscuro" },
        { tag: "Concepto de app", title: "Experiencia móvil" },
      ],
      ctaT: "Tu proyecto va aquí",
      ctaB: "Reserva el hueco — empieza tu proyecto",
    },
    contact: {
      overline: "Contacto",
      h2a: "¿Interesado?",
      h2b: "Genial. Cuéntanos.",
      body: "Dinos cuántas páginas quieres y qué deben hacer. Si respondemos, te enviaremos nuestro WhatsApp y un precio a medida — directo a tu correo.",
      name: "Tu nombre *",
      namePh: "Tu nombre completo",
      email: "Correo *",
      emailPh: "tu@empresa.com",
      business: "Nombre del negocio / proyecto (opcional)",
      businessPh: "Tu empresa",
      pages: "¿Cuántas páginas quieres? *",
      pagesHint: "¿No lo sabes? Elige cualquier número — lo resolvemos juntos.",
      features: "¿Qué quieres incluir?",
      message: "Cuéntanos más (opcional)",
      messagePh: "¿Cuál es la idea? ¿Para quién es? ¿Alguna web que te guste?",
      submit: "Enviar mi idea",
      sending: "Enviando...",
      hint: "Respondemos personalmente — espera nuestro WhatsApp y un precio a medida en tu correo.",
      successT: "Idea recibida.",
      successBody: "¡Gracias, {name}! Responderemos a {email} con nuestro número de WhatsApp y un precio a medida para tu proyecto.",
      sendAnother: "Enviar otra idea",
      errName: "Por favor, dinos tu nombre.",
      errEmail: "Introduce un correo válido para poder responderte.",
      toastSuccess: "¡Idea enviada! Revisa tu correo.",
    },
    features: ["Página de aterrizaje", "Web de empresa", "Tienda online", "Portafolio", "Blog", "Sistema de reservas", "Panel / app web", "Otra cosa"],
    footer: {
      overline: "¿Interesado? Escríbenos.",
      body: "Escríbenos cuando quieras — respondemos personalmente con nuestro WhatsApp y un precio a medida.",
      tagline: "Dirigido por dos prodigios",
      copyright: "© {year} Web Builders",
    },
  },
  lb: {
    nav: { founders: "Grënner", services: "Servicer", work: "Aarbecht", cta: "Projet starten" },
    hero: {
      eyebrow: "Web Builders — Webdesign-Studio",
      l1: "MIR BAUEN",
      l2: "DE WEB.",
      l3: "BRILLANT.",
      sub: "Zwou 12 Joer al Zwillingen aus Indien, déi séier, impressionant Websäiten designen a programméieren — keng Schablounen, keng Tëscheleit.",
      cta: "Start däi Projet",
      scroll: "Scroll",
    },
    marquee: ["Gefouert vun zwou Prodigyen", "Websäiten no Mooss", "Premium Design", "Séier geliwwert", "Null Schablounen", "Web Builders"],
    founders: {
      overline: "D'Grënner",
      h2a: "Zwillinge-Prodigyen.",
      h2b: "Ee Studio.",
      p1: "Web Builders gëtt vum Vikraanth a vum Vaibhhav gefouert — 12 Joer al Zwillingen aus Indien, déi sech an de Web verléift hunn an drop erstaunlech gutt goufen. Design, Code, Text a Launch: déi zwee maachen alles selwer.",
      p2: "All Pixel geet duerch hir véier Hänn, an all Client kritt Grënner, déi wierklech äntweren.",
      role: "Co-Grënner, Web Builders",
      twins: "Zwillingen · 12 Joer · Indien",
      mentor: {
        label: "Eis Mentorin",
        body: "Software-Professionell, baséiert zu Lëtzebuerg, si huet bei globale Produkt- a Softwarefirmen wéi BMC Software, Kodiak Networks an Emphasis geschafft.",
        extra: "Si bréngt ronderëm 20 Joer Erfarung an Technologie, Design, Architektur an Ëmsetzung mat.",
        tags: ["Lëtzebuerg", "20 Joer Erfarung"],
      },
      daisy: {
        label: "Éierlech Ernennung",
        body: "Si ass d'Motivatioun an d'Ënnerstëtzung vun de Kanner, ëmmer fir si do. Si ass eng vun de séisste Schwesteren iwwerhaapt.",
      },
      points: [
        { t: "Design + Code, déi selwecht Hänn", b: "Keng Iwwergaben, kee still Post. Deen deen däin Site designt, schéift en och online." },
        { t: "Direkt Linn zu de Builderen", b: "Du schwätzt mat deenen zwee Leit, déi deng Websäit wierklech bauen. Näischt geet verluer." },
        { t: "Jonk Aen, al Handwierk", b: "Mir si mam Internet opgewuess, dohinner baue mir en esou wéi en sech ufillen soll — séier, schaarf, lieweg." },
      ],
    },
    services: {
      overline: "Wat mir bauen",
      h2: "Sief däi Build.",
      side: "All Projet gëtt vu null un ronderëm deng Iddi designt a programméiert — ni an eng Schabloun gequetscht.",
      items: [
        { t: "Landing Pages", b: "Eng Säit, eng Missioun: de Visiteur soll handelen. Schaarfe Text, mutt Design, Blëtz-Geschwindegkeet." },
        { t: "Business-Websäiten", b: "Méi-Säite-Websäiten, déi kleng Geschäfter vum éischten Dag un etabléiert ausse loossen." },
        { t: "Online-Buttek", b: "Storefronten gebaut fir ze verkafen — propper Kataloge, séieren Checkout, null Friktioun." },
        { t: "Portfolioen a CV-en", b: "Perséinlech Säiten, déi dech onvergiesslech maachen — an astellen." },
        { t: "Web-Apps an Dashboards", b: "Individuell Tools, Buchungssystemer an Dashboards mat richtege Daten." },
      ],
      customT: "Eppes ganz anescht?",
      customB: "Sot eis d'Iddi — mir maache Säiten an e Plang domat.",
    },
    work: {
      overline: "D'Aarbecht",
      h2a: "Frësch Bauten,",
      h2b: "null Schablounen.",
      side: "Konsepter déi mir maachen an d'Zort Säiten déi mir liwweren. Däng kënnt genau heihinner.",
      cards: [
        { tag: "E-Commerce-Konzept", title: "Storefront am Dark Mode" },
        { tag: "App-Konzept", title: "Mobil Erfarung" },
      ],
      ctaT: "Däi Projet kënnt heihinner",
      ctaB: "Sécher d'Plaz — start däi Projet",
    },
    contact: {
      overline: "Kontaktéier eis",
      h2a: "Interesséiert?",
      h2b: "Gutt. Sot et eis.",
      body: "Sot eis wéi vill Säiten de wëlls a wat se maache solle. Wann mir äntweren, schécke mir eis WhatsApp-Nummer an e personaliséierte Präis — direkt an däin Inbox.",
      name: "Däin Numm *",
      namePh: "Däi ganchen Numm",
      email: "E-Mail *",
      emailPh: "du@firma.lu",
      business: "Geschäfts- / Projetnumm (optional)",
      businessPh: "Deng Firma",
      pages: "Wéi vill Säiten wëlls du? *",
      pagesHint: "Net sécher? Huel eng Zuel — mir fannen et zesummen eraus.",
      features: "Wat soll dran sinn?",
      message: "Sot eis méi (optional)",
      messagePh: "Wat ass d'Iddi? Fir wen ass se? Gëtt et Säiten déi de gees hues?",
      submit: "Meng Iddi schécken",
      sending: "Gëtt geschéckt...",
      hint: "Mir äntwere perséinlech — erwaart eis WhatsApp-Nummer an e personaliséierte Präis an däin Inbox.",
      successT: "Iddi ugholl.",
      successBody: "Merci, {name}! Mir äntweren op {email} mat eiser WhatsApp-Nummer an engem personaliséierte Präis fir däi Projet.",
      sendAnother: "Eng aner Iddi schécken",
      errName: "Sot eis w.e.g. däin Numm.",
      errEmail: "Gëff eng gëlteg E-Mail un, soudatt mir äntwere kënnen.",
      toastSuccess: "Iddi geschéckt! Kuck an däin Inbox.",
    },
    features: ["Landing Page", "Business-Websäit", "Online-Buttek", "Portfolio", "Blog", "Buchungssystem", "Dashboard / Web-App", "Eppes anescht"],
    footer: {
      overline: "Interesséiert? Kontaktéier eis.",
      body: "Schreif eis zu all Zäit — mir äntwere perséinlech mat eiser WhatsApp-Nummer an engem personaliséierte Präis.",
      tagline: "Gefouert vun zwou Prodigyen",
      copyright: "© {year} Web Builders",
    },
  },
  de: {
    nav: { founders: "Gründer", services: "Leistungen", work: "Arbeiten", cta: "Projekt starten" },
    hero: {
      eyebrow: "Web Builders — Webdesign-Studio",
      l1: "WIR BAUEN",
      l2: "DAS WEB.",
      l3: "BRILLANT.",
      sub: "Zwei 12-jährige Zwillinge aus Indien designen und programmieren beeindruckende, schnelle Websites — keine Templates, keine Mittelsmänner.",
      cta: "Starte dein Projekt",
      scroll: "Scrollen",
    },
    marquee: ["Geführt von zwei Wunderkindern", "Individuelle Web-Builds", "Premium-Design", "Schnelle Lieferung", "Null Templates", "Web Builders"],
    founders: {
      overline: "Die Gründer",
      h2a: "Zwillings-Wunderkinder.",
      h2b: "Ein Studio.",
      p1: "Web Builders wird von Vikraanth und Vaibhhav geführt — 12-jährige Zwillinge aus Indien, die sich ins Web verliebt haben und erschreckend gut darin geworden sind. Design, Code, Text und Launch: Die beiden machen alles selbst.",
      p2: "Jedes Pixel geht durch ihre vier Hände, und jeder Kunde bekommt Gründer, die wirklich antworten.",
      role: "Mitgründer, Web Builders",
      twins: "Zwillinge · 12 Jahre · Indien",
      mentor: {
        label: "Unsere Mentorin",
        body: "Software-Expertin mit Sitz in Luxemburg, sie hat bei globalen Produkt- und Softwarefirmen wie BMC Software, Kodiak Networks und Emphasis gearbeitet.",
        extra: "Sie bringt rund 20 Jahre Erfahrung in Technologie, Design, Architektur und Implementierung mit.",
        tags: ["Luxemburg", "20 Jahre Erfahrung"],
      },
      daisy: {
        label: "Ehrenvolle Erwähnung",
        body: "Sie ist die Motivation und Unterstützung der Kinder, immer für sie da. Sie ist eine der süßesten Schwestern überhaupt.",
      },
      points: [
        { t: "Design + Code, dieselben Hände", b: "Keine Übergaben, kein Stille-Post-Spiel. Wer deine Website designt, bringt sie auch live." },
        { t: "Direkter Draht zu den Buildern", b: "Du sprichst mit den beiden, die deine Website wirklich bauen. Nichts geht verloren." },
        { t: "Junge Augen, altes Handwerk", b: "Wir sind im Internet aufgewachsen — darum bauen wir es so, wie es sich anfühlen soll: schnell, scharf, lebendig." },
      ],
    },
    services: {
      overline: "Was wir bauen",
      h2: "Wähl dein Build.",
      side: "Jedes Projekt wird von Grund auf um deine Idee herum designt und programmiert — nie in ein Template gequetscht.",
      items: [
        { t: "Landingpages", b: "Eine Seite, ein Job: Besucher zur Aktion bringen. Scharfer Text, mutiges Design, Blitztempo." },
        { t: "Business-Websites", b: "Mehrseitige Websites, die kleine Unternehmen vom ersten Tag an etabliert wirken lassen." },
        { t: "Online-Shops", b: "Shops gebaut zum Verkaufen — saubere Kataloge, reibungsloser Checkout, null Reibung." },
        { t: "Portfolios & Lebensläufe", b: "Persönliche Websites, die dich unvergesslich machen — und einstellen." },
        { t: "Web-Apps & Dashboards", b: "Individuelle Tools, Buchungssysteme und Dashboards mit echten Daten." },
      ],
      customT: "Etwas ganz anderes?",
      customB: "Erzähl uns die Idee — wir formen sie gemeinsam zu Seiten und einem Plan.",
    },
    work: {
      overline: "Die Arbeit",
      h2a: "Frische Builds,",
      h2b: "null Templates.",
      side: "Konzepte, die wir bauen, und die Art von Websites, die wir liefern. Deine kommt genau hierhin.",
      cards: [
        { tag: "E-Commerce-Konzept", title: "Storefront im Dark Mode" },
        { tag: "App-Konzept", title: "Mobile Experience" },
      ],
      ctaT: "Dein Projekt gehört hierhin",
      ctaB: "Sichere den Platz — starte dein Projekt",
    },
    contact: {
      overline: "Kontakt",
      h2a: "Interessiert?",
      h2b: "Gut. Erzähl uns.",
      body: "Sag uns, wie viele Seiten du willst und was sie können sollen. Wenn wir antworten, schicken wir unsere WhatsApp-Nummer und einen individuellen Preis — direkt in dein Postfach.",
      name: "Dein Name *",
      namePh: "Dein vollständiger Name",
      email: "E-Mail *",
      emailPh: "du@firma.de",
      business: "Firmen- / Projektname (optional)",
      businessPh: "Deine Firma",
      pages: "Wie viele Seiten möchtest du? *",
      pagesHint: "Nicht sicher? Wähl eine Zahl — wir finden es gemeinsam heraus.",
      features: "Was soll rein?",
      message: "Erzähl uns mehr (optional)",
      messagePh: "Was ist die Idee? Für wen ist sie? Websites, die dir gefallen?",
      submit: "Meine Idee senden",
      sending: "Wird gesendet...",
      hint: "Wir antworten persönlich — erwarte unsere WhatsApp-Nummer und einen individuellen Preis in deinem Postfach.",
      successT: "Idee erhalten.",
      successBody: "Danke, {name}! Wir antworten an {email} mit unserer WhatsApp-Nummer und einem individuellen Preis für dein Projekt.",
      sendAnother: "Weitere Idee senden",
      errName: "Bitte sag uns deinen Namen.",
      errEmail: "Bitte gib eine gültige E-Mail an, damit wir antworten können.",
      toastSuccess: "Idee gesendet! Behalte dein Postfach im Auge.",
    },
    features: ["Landingpage", "Business-Website", "Online-Shop", "Portfolio", "Blog", "Buchungssystem", "Dashboard / Web-App", "Etwas anderes"],
    footer: {
      overline: "Interessiert? Schreib uns.",
      body: "Schreib uns jederzeit — wir antworten persönlich mit unserer WhatsApp-Nummer und einem individuellen Preis.",
      tagline: "Geführt von zwei Wunderkindern",
      copyright: "© {year} Web Builders",
    },
  },
  fr: {
    nav: { founders: "Fondateurs", services: "Services", work: "Réalisations", cta: "Lancer un projet" },
    hero: {
      eyebrow: "Web Builders — Studio de design web",
      l1: "NOUS BÂTISSONS",
      l2: "LE WEB.",
      l3: "BRILLAMMENT.",
      sub: "Deux jumeaux de 12 ans venus d'Inde qui conçoivent et codent des sites rapides et saisissants — sans modèles ni intermédiaires.",
      cta: "Lancez votre projet",
      scroll: "Défiler",
    },
    marquee: ["Mené par deux prodiges", "Sites web sur mesure", "Design premium", "Livraison rapide", "Zéro modèle", "Web Builders"],
    founders: {
      overline: "Les fondateurs",
      h2a: "Jumeaux prodiges.",
      h2b: "Un seul studio.",
      p1: "Web Builders est dirigé par Vikraanth et Vaibhhav — des jumeaux de 12 ans venus d'Inde, tombés amoureux du web et devenus redoutablement doués pour le construire. Design, code, textes et lancement : ils font tout eux-mêmes.",
      p2: "Chaque pixel passe entre leurs quatre mains, et chaque client parle à des fondateurs qui répondent vraiment.",
      role: "Cofondateur, Web Builders",
      twins: "Jumeaux · 12 ans · Inde",
      mentor: {
        label: "Notre mentore",
        body: "Professionnelle du logiciel, basée au Luxembourg, elle a travaillé avec des sociétés mondiales de produits et de logiciels comme BMC Software, Kodiak Networks et Emphasis.",
        extra: "Elle apporte environ 20 ans d'expérience en technologie, design, architecture et implémentation.",
        tags: ["Luxembourg", "20 ans d'expérience"],
      },
      daisy: {
        label: "Mention honorable",
        body: "Elle est la motivation et le soutien des enfants, toujours là pour eux. C'est l'une des sœurs les plus adorables qui soient.",
      },
      points: [
        { t: "Design + code, mêmes mains", b: "Pas de passations, pas de téléphone arabe. Celui qui dessine votre site est celui qui le met en ligne." },
        { t: "Ligne directe avec les bâtisseurs", b: "Vous parlez aux deux personnes qui construisent vraiment votre site. Rien ne se perd en route." },
        { t: "Regard jeune, savoir-faire ancien", b: "Nous avons grandi dans l'internet, alors nous le construisons comme il doit se ressentir — rapide, net, vivant." },
      ],
    },
    services: {
      overline: "Ce que nous bâtissons",
      h2: "Choisissez votre projet.",
      side: "Chaque projet est conçu et codé de zéro autour de votre idée — jamais compressé dans un modèle.",
      items: [
        { t: "Pages d'atterrissage", b: "Une page, une mission : faire agir le visiteur. Texte affûté, design audacieux, vitesse éclair." },
        { t: "Sites d'entreprise", b: "Des sites multipages qui donnent aux petites entreprises une allure établie dès le premier jour." },
        { t: "Boutiques en ligne", b: "Des vitrines conçues pour vendre — catalogues épurés, paiement fluide, zéro friction." },
        { t: "Portfolios & CV", b: "Des sites personnels qui vous rendent mémorable — et recrutable." },
        { t: "Apps web & tableaux de bord", b: "Des outils sur mesure, des systèmes de réservation et des tableaux de bord connectés à de vraies données." },
      ],
      customT: "Quelque chose de tout autre ?",
      customB: "Racontez-nous l'idée — nous la transformerons ensemble en pages et en plan.",
    },
    work: {
      overline: "Nos réalisations",
      h2a: "Créations fraîches,",
      h2b: "zéro modèle.",
      side: "Des concepts que nous créons et le type de sites que nous livrons. Le vôtre ira juste ici.",
      cards: [
        { tag: "Concept e-commerce", title: "Vitrine en mode sombre" },
        { tag: "Concept d'app", title: "Expérience mobile" },
      ],
      ctaT: "Votre projet ira ici",
      ctaB: "Réservez la place — lancez votre projet",
    },
    contact: {
      overline: "Contact",
      h2a: "Intéressé ?",
      h2b: "Parfait. Dites-nous.",
      body: "Dites-nous combien de pages vous voulez et ce qu'elles doivent faire. Si nous répondons, nous vous enverrons notre numéro WhatsApp et un prix sur mesure — directement dans votre boîte mail.",
      name: "Votre nom *",
      namePh: "Votre nom complet",
      email: "E-mail *",
      emailPh: "vous@entreprise.com",
      business: "Nom de l'entreprise / du projet (optionnel)",
      businessPh: "Votre entreprise",
      pages: "Combien de pages voulez-vous ? *",
      pagesHint: "Pas sûr ? Choisissez un nombre — on décidera ensemble.",
      features: "Que faut-il inclure ?",
      message: "Dites-nous en plus (optionnel)",
      messagePh: "Quelle est l'idée ? Pour qui ? Des sites que vous aimez ?",
      submit: "Envoyer mon idée",
      sending: "Envoi...",
      hint: "Nous répondons personnellement — attendez notre numéro WhatsApp et un prix sur mesure dans votre boîte mail.",
      successT: "Idée bien reçue.",
      successBody: "Merci, {name} ! Nous répondrons à {email} avec notre numéro WhatsApp et un prix sur mesure pour votre projet.",
      sendAnother: "Envoyer une autre idée",
      errName: "Merci de nous indiquer votre nom.",
      errEmail: "Saisissez un e-mail valide pour que nous puissions répondre.",
      toastSuccess: "Idée envoyée ! Surveillez votre boîte mail.",
    },
    features: ["Page d'atterrissage", "Site d'entreprise", "Boutique en ligne", "Portfolio", "Blog", "Système de réservation", "Tableau de bord / app web", "Autre chose"],
    footer: {
      overline: "Intéressé ? Écrivez-nous.",
      body: "Écrivez-nous à tout moment — nous répondons personnellement avec notre numéro WhatsApp et un prix sur mesure.",
      tagline: "Mené par deux prodiges",
      copyright: "© {year} Web Builders",
    },
  },
  pt: {
    nav: { founders: "Fundadores", services: "Serviços", work: "Trabalhos", cta: "Começar projeto" },
    hero: {
      eyebrow: "Web Builders — Estúdio de design web",
      l1: "CONSTRUÍMOS",
      l2: "A WEB.",
      l3: "COM BRILHO.",
      sub: "Dois gêmeos de 12 anos da Índia que desenham e programam sites rápidos e marcantes — sem modelos nem intermediários.",
      cta: "Comece seu projeto",
      scroll: "Role",
    },
    marquee: ["Comandado por dois prodígios", "Sites sob medida", "Design premium", "Entrega rápida", "Zero modelos", "Web Builders"],
    founders: {
      overline: "Os fundadores",
      h2a: "Gêmeos prodígio.",
      h2b: "Um só estúdio.",
      p1: "A Web Builders é comandada por Vikraanth e Vaibhhav — gêmeos de 12 anos da Índia que se apaixonaram pela web e ficaram assustadoramente bons em construí-la. Design, código, textos e lançamento: os dois fazem tudo sozinhos.",
      p2: "Cada pixel passa pelas quatro mãos deles, e cada cliente fala com fundadores que realmente respondem.",
      role: "Cofundador, Web Builders",
      twins: "Gêmeos · 12 anos · Índia",
      mentor: {
        label: "Nossa mentora",
        body: "Profissional de software, sediada em Luxemburgo, trabalhou com empresas globais de produtos e software como BMC Software, Kodiak Networks e Emphasis.",
        extra: "Ela traz cerca de 20 anos de experiência em tecnologia, design, arquitetura e implementação.",
        tags: ["Luxemburgo", "20 anos de experiência"],
      },
      daisy: {
        label: "Menção honrosa",
        body: "Ela é a motivação e o apoio das crianças, sempre presente para elas. É uma das irmãs mais fofas que existem.",
      },
      points: [
        { t: "Design + código, as mesmas mãos", b: "Sem repasses, sem telefone sem fio. Quem desenha seu site é quem o coloca no ar." },
        { t: "Linha direta com os construtores", b: "Você fala com as duas pessoas que realmente constroem seu site. Nada se perde no caminho." },
        { t: "Olhos jovens, ofício antigo", b: "Crescemos dentro da internet, então a construímos como ela deve ser — rápida, nítida, viva." },
      ],
    },
    services: {
      overline: "O que construímos",
      h2: "Escolha seu projeto.",
      side: "Cada projeto é desenhado e programado do zero em torno da sua ideia — nunca espremido num modelo.",
      items: [
        { t: "Páginas de destino", b: "Uma página, uma missão: fazer o visitante agir. Texto afiado, design ousado, velocidade de raio." },
        { t: "Sites empresariais", b: "Sites de várias páginas que fazem pequenas empresas parecerem consolidadas desde o primeiro dia." },
        { t: "Lojas online", b: "Vitrines feitas para vender — catálogos limpos, checkout fluido, zero fricção." },
        { t: "Portfólios e currículos", b: "Sites pessoais que tornam você inesquecível — e contratável." },
        { t: "Apps web e painéis", b: "Ferramentas sob medida, sistemas de reserva e painéis ligados a dados reais." },
      ],
      customT: "Algo totalmente diferente?",
      customB: "Conte a ideia — vamos transformá-la em páginas e num plano, juntos.",
    },
    work: {
      overline: "O trabalho",
      h2a: "Criações novas,",
      h2b: "zero modelos.",
      side: "Conceitos que criamos e o tipo de site que entregamos. O seu entra bem aqui.",
      cards: [
        { tag: "Conceito de e-commerce", title: "Vitrine em modo escuro" },
        { tag: "Conceito de app", title: "Experiência mobile" },
      ],
      ctaT: "Seu projeto entra aqui",
      ctaB: "Garanta o lugar — comece seu projeto",
    },
    contact: {
      overline: "Fale conosco",
      h2a: "Interessado?",
      h2b: "Ótimo. Conte pra gente.",
      body: "Diga quantas páginas você quer e o que elas devem fazer. Se respondermos, enviaremos nosso WhatsApp e um preço sob medida — direto para sua caixa de entrada.",
      name: "Seu nome *",
      namePh: "Seu nome completo",
      email: "E-mail *",
      emailPh: "voce@empresa.com",
      business: "Nome da empresa / projeto (opcional)",
      businessPh: "Sua empresa",
      pages: "Quantas páginas você quer? *",
      pagesHint: "Não sabe? Escolha um número — a gente resolve junto.",
      features: "O que você quer nele?",
      message: "Conte mais (opcional)",
      messagePh: "Qual é a ideia? Para quem é? Algum site que você goste?",
      submit: "Enviar minha ideia",
      sending: "Enviando...",
      hint: "Respondemos pessoalmente — espere nosso WhatsApp e um preço sob medida na sua caixa de entrada.",
      successT: "Ideia recebida.",
      successBody: "Obrigado, {name}! Responderemos para {email} com nosso número de WhatsApp e um preço sob medida para o seu projeto.",
      sendAnother: "Enviar outra ideia",
      errName: "Por favor, diga seu nome.",
      errEmail: "Digite um e-mail válido para podermos responder.",
      toastSuccess: "Ideia enviada! Fique de olho na sua caixa de entrada.",
    },
    features: ["Página de destino", "Site empresarial", "Loja online", "Portfólio", "Blog", "Sistema de reservas", "Painel / app web", "Outra coisa"],
    footer: {
      overline: "Interessado? Fale conosco.",
      body: "Escreva quando quiser — respondemos pessoalmente com nosso WhatsApp e um preço sob medida.",
      tagline: "Comandado por dois prodígios",
      copyright: "© {year} Web Builders",
    },
  },
  it: {
    nav: { founders: "Fondatori", services: "Servizi", work: "Lavori", cta: "Avvia un progetto" },
    hero: {
      eyebrow: "Web Builders — Studio di web design",
      l1: "COSTRUIAMO",
      l2: "IL WEB.",
      l3: "BRILLANTEMENTE.",
      sub: "Due gemelli di 12 anni dall'India che progettano e programmano siti veloci e sorprendenti — senza modelli né intermediari.",
      cta: "Avvia il tuo progetto",
      scroll: "Scorri",
    },
    marquee: ["Guidato da due piccoli prodigi", "Siti su misura", "Design premium", "Consegna rapida", "Zero modelli", "Web Builders"],
    founders: {
      overline: "I fondatori",
      h2a: "Gemelli prodigio.",
      h2b: "Un solo studio.",
      p1: "Web Builders è guidata da Vikraanth e Vaibhhav — gemelli di 12 anni dall'India che si sono innamorati del web e sono diventati incredibilmente bravi a costruirlo. Design, codice, testi e lancio: fanno tutto da soli.",
      p2: "Ogni pixel passa dalle loro quattro mani, e ogni cliente parla con fondatori che rispondono davvero.",
      role: "Cofondatore, Web Builders",
      twins: "Gemelli · 12 anni · India",
      mentor: {
        label: "La nostra mentore",
        body: "Professionista del software, con base in Lussemburgo, ha lavorato con aziende globali di prodotti e software come BMC Software, Kodiak Networks ed Emphasis.",
        extra: "Porta circa 20 anni di esperienza in tecnologia, design, architettura e implementazione.",
        tags: ["Lussemburgo", "20 anni di esperienza"],
      },
      daisy: {
        label: "Menzione d'onore",
        body: "È la motivazione e il sostegno dei ragazzi, sempre al loro fianco. È una delle sorelle più dolci che ci siano.",
      },
      points: [
        { t: "Design + codice, stesse mani", b: "Niente passaggi di consegne. Chi disegna il tuo sito è chi lo mette online." },
        { t: "Linea diretta con i costruttori", b: "Parli con le due persone che costruiscono davvero il tuo sito. Nulla si perde per strada." },
        { t: "Occhi giovani, mestiere antico", b: "Siamo cresciuti dentro internet, quindi lo costruiamo come deve essere — veloce, nitido, vivo." },
      ],
    },
    services: {
      overline: "Cosa costruiamo",
      h2: "Scegli il tuo progetto.",
      side: "Ogni progetto è progettato e programmato da zero intorno alla tua idea — mai infilato in un modello.",
      items: [
        { t: "Landing page", b: "Una pagina, una missione: far agire il visitatore. Testo affilato, design audace, velocità fulminea." },
        { t: "Siti aziendali", b: "Siti multipagina che fanno sembrare consolidate le piccole imprese fin dal primo giorno." },
        { t: "Negozi online", b: "Vetrine costruite per vendere — cataloghi puliti, checkout fluido, zero attriti." },
        { t: "Portfolio e CV", b: "Siti personali che ti rendono indimenticabile — e assumibile." },
        { t: "Web app e dashboard", b: "Strumenti su misura, sistemi di prenotazione e dashboard collegati a dati reali." },
      ],
      customT: "Qualcosa di completamente diverso?",
      customB: "Raccontaci l'idea — la trasformeremo insieme in pagine e in un piano.",
    },
    work: {
      overline: "I lavori",
      h2a: "Creazioni nuove,",
      h2b: "zero modelli.",
      side: "I concept che creiamo e il tipo di siti che consegniamo. Il tuo andrà proprio qui.",
      cards: [
        { tag: "Concept e-commerce", title: "Vetrina in dark mode" },
        { tag: "Concept app", title: "Esperienza mobile" },
      ],
      ctaT: "Il tuo progetto andrà qui",
      ctaB: "Prenota il posto — avvia il tuo progetto",
    },
    contact: {
      overline: "Contattaci",
      h2a: "Interessato?",
      h2b: "Ottimo. Dicci tutto.",
      body: "Dicci quante pagine vuoi e cosa devono fare. Se rispondiamo, ti invieremo il nostro WhatsApp e un prezzo su misura — direttamente nella tua casella.",
      name: "Il tuo nome *",
      namePh: "Il tuo nome completo",
      email: "E-mail *",
      emailPh: "tu@azienda.it",
      business: "Nome dell'azienda / progetto (opzionale)",
      businessPh: "La tua azienda",
      pages: "Quante pagine vuoi? *",
      pagesHint: "Non sei sicuro? Scegli un numero — lo decidiamo insieme.",
      features: "Cosa deve contenere?",
      message: "Raccontaci di più (opzionale)",
      messagePh: "Qual è l'idea? Per chi è? Siti che ti piacciono?",
      submit: "Invia la mia idea",
      sending: "Invio in corso...",
      hint: "Rispondiamo personalmente — aspettati il nostro WhatsApp e un prezzo su misura nella tua casella.",
      successT: "Idea ricevuta.",
      successBody: "Grazie, {name}! Risponderemo a {email} con il nostro numero WhatsApp e un prezzo su misura per il tuo progetto.",
      sendAnother: "Invia un'altra idea",
      errName: "Per favore, dicci il tuo nome.",
      errEmail: "Inserisci un'e-mail valida così possiamo risponderti.",
      toastSuccess: "Idea inviata! Tieni d'occhio la tua casella.",
    },
    features: ["Landing page", "Sito aziendale", "Negozio online", "Portfolio", "Blog", "Sistema di prenotazioni", "Dashboard / web app", "Altro"],
    footer: {
      overline: "Interessato? Scrivici.",
      body: "Scrivici quando vuoi — rispondiamo personalmente con il nostro WhatsApp e un prezzo su misura.",
      tagline: "Guidato da due piccoli prodigi",
      copyright: "© {year} Web Builders",
    },
  },
  ja: {
    nav: { founders: "創設者", services: "サービス", work: "実績", cta: "プロジェクトを開始" },
    hero: {
      eyebrow: "Web Builders — ウェブデザインスタジオ",
      l1: "私たちは",
      l2: "ウェブを",
      l3: "鮮やかに作る。",
      sub: "インド出身の12歳の双子が、印象的で速いウェブサイトをデザインしコーディングします — テンプレートなし、仲介なし。",
      cta: "プロジェクトを始める",
      scroll: "スクロール",
    },
    marquee: ["2人の天才児が運営", "カスタムウェブ制作", "プレミアムデザイン", "スピード納品", "テンプレート不使用", "Web Builders"],
    founders: {
      overline: "創設者",
      h2a: "天才の双子。",
      h2b: "ひとつのスタジオ。",
      p1: "Web Buildersを運営するのは、VikraanthとVaibhhav — ウェブに恋をし、その構築に恐ろしく長けた、インド出身の12歳の双子です。デザイン、コード、コピー、公開まで、すべて2人でこなします。",
      p2: "すべてのピクセルが彼らの4つの手を通り、すべてのクライアントに本当に返信する創設者が対応します。",
      role: "共同創設者、Web Builders",
      twins: "双子 · 12歳 · インド",
      mentor: {
        label: "私たちのメンター",
        body: "ルクセンブルクを拠点とするソフトウェアのプロフェッショナル。BMC Software、Kodiak Networks、Emphasisなど世界的なプロダクト・ソフトウェア企業で経験を積んできました。",
        extra: "テクノロジー、デザイン、アーキテクチャ、実装における約20年の経験をもたらします。",
        tags: ["ルクセンブルク", "20年の経験"],
      },
      daisy: {
        label: "特別賞",
        body: "彼女は子どもたちの励みであり支え。いつもそばにいてくれます。世界でいちばん可愛い姉妹のひとりです。",
      },
      points: [
        { t: "デザインもコードも同じ手で", b: "引き継ぎなし、伝言ゲームなし。あなたのサイトをデザインする子が、そのまま公開まで仕上げます。" },
        { t: "制作者と直接つながる", b: "実際にサイトを作っている2人と直接話せます。途中で何も失われません。" },
        { t: "若い目と、確かな技術", b: "私たちはインターネットの中で育ちました。だから、あるべき姿で作ります — 速く、鋭く、生き生きと。" },
      ],
    },
    services: {
      overline: "制作内容",
      h2: "作りたいものを選ぶ。",
      side: "すべてのプロジェクトはあなたのアイデアを中心にゼロから設計・開発します。テンプレートに押し込むことは決してありません。",
      items: [
        { t: "ランディングページ", b: "1ページ、1つの使命：訪問者に行動してもらうこと。研ぎ澄まされたコピー、大胆なデザイン、稲妻の速さ。" },
        { t: "ビジネスサイト", b: "小さなビジネスを初日から確立されたように見せる、複数ページのサイト。" },
        { t: "オンラインストア", b: "売るために作られたストアフロント — クリーンなカタログ、スムーズな決済、摩擦ゼロ。" },
        { t: "ポートフォリオ＆履歴書", b: "記憶に残り、採用につながる個人サイト。" },
        { t: "ウェブアプリ＆ダッシュボード", b: "カスタムツール、予約システム、実データと連携するダッシュボード。" },
      ],
      customT: "まったく別の何か？",
      customB: "アイデアを聞かせてください — 一緒にページと計画に仕上げます。",
    },
    work: {
      overline: "実績",
      h2a: "新鮮な制作物、",
      h2b: "テンプレートゼロ。",
      side: "私たちが作るコンセプトと、納品するサイトの種類。あなたのサイトはここに入ります。",
      cards: [
        { tag: "Eコマースコンセプト", title: "ダークモードのストアフロント" },
        { tag: "アプリコンセプト", title: "モバイル体験" },
      ],
      ctaT: "あなたのプロジェクトはここへ",
      ctaB: "枠を確保 — プロジェクトを始める",
    },
    contact: {
      overline: "お問い合わせ",
      h2a: "興味がありますか？",
      h2b: "ぜひ聞かせてください。",
      body: "何ページ必要で、何を実現したいか教えてください。返信する際は、WhatsApp番号とカスタム価格を直接メールでお送りします。",
      name: "お名前 *",
      namePh: "お名前（フルネーム）",
      email: "メール *",
      emailPh: "you@company.com",
      business: "会社 / プロジェクト名（任意）",
      businessPh: "会社名",
      pages: "何ページ必要ですか？ *",
      pagesHint: "未定ですか？適当な数字でOK — 一緒に決めましょう。",
      features: "何を入れますか？",
      message: "もっと教えてください（任意）",
      messagePh: "どんなアイデア？誰のため？好きなサイトは？",
      submit: "アイデアを送る",
      sending: "送信中...",
      hint: "必ず本人が返信します — 受信トレイにWhatsApp番号とカスタム価格が届きます。",
      successT: "アイデアを受け取りました。",
      successBody: "ありがとう、{name}さん！{email} にWhatsApp番号とカスタム価格をお送りします。",
      sendAnother: "別のアイデアを送る",
      errName: "お名前を教えてください。",
      errEmail: "返信できるよう、有効なメールアドレスを入力してください。",
      toastSuccess: "送信しました！受信トレイをご確認ください。",
    },
    features: ["ランディングページ", "ビジネスサイト", "オンラインストア", "ポートフォリオ", "ブログ", "予約システム", "ダッシュボード / ウェブアプリ", "その他"],
    footer: {
      overline: "興味がありますか？ご連絡ください。",
      body: "いつでもメールしてください — WhatsApp番号とカスタム価格を添えて、必ず本人が返信します。",
      tagline: "2人の天才児が運営",
      copyright: "© {year} Web Builders",
    },
  },
};
